var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
System.register([], function(exports, module) {
  "use strict";
  return {
    execute: function() {
      var _a, _b;
      exports({
        a: isBreakpoint,
        g: getDefaultExportFromCjs,
        h: hex2rgb,
        i: isMobile
      });
      const debounce = exports("d", ({ delay }, func) => {
        let timer = void 0;
        let active = true;
        const debounced = (...args) => {
          if (active) {
            clearTimeout(timer);
            timer = setTimeout(() => {
              active && func(...args);
              timer = void 0;
            }, delay);
          } else {
            func(...args);
          }
        };
        debounced.isPending = () => {
          return timer !== void 0;
        };
        debounced.cancel = () => {
          active = false;
        };
        debounced.flush = (...args) => func(...args);
        return debounced;
      });
      const throttle = exports("t", ({ interval }, func) => {
        let ready = true;
        let timer = void 0;
        const throttled = (...args) => {
          if (!ready)
            return;
          func(...args);
          ready = false;
          timer = setTimeout(() => {
            ready = true;
            timer = void 0;
          }, interval);
        };
        throttled.isThrottled = () => {
          return timer !== void 0;
        };
        return throttled;
      });
      const get = (value, path, defaultValue) => {
        const segments = path.split(/[\.\[\]]/g);
        let current = value;
        for (const key of segments) {
          if (current === null)
            return defaultValue;
          if (current === void 0)
            return defaultValue;
          const dequoted = key.replace(/['"]/g, "");
          if (dequoted.trim() === "")
            continue;
          current = current[dequoted];
        }
        if (current === void 0)
          return defaultValue;
        return current;
      };
      const sall = exports("s", (fn) => fn());
      function isBreakpoint(query) {
        const mediaQuery = window.matchMedia(query);
        return mediaQuery.matches;
      }
      function isMobile() {
        return isBreakpoint("(max-width: 767px)");
      }
      function lib(l) {
        return () => l();
      }
      function hex2rgb(hex) {
        const color = parseInt(hex.slice(1), 16);
        const r = color >> 16 & 255;
        const g = color >> 8 & 255;
        const b = color & 255;
        return {
          r,
          g,
          b
        };
      }
      const libInvoke = lib(() => Promise.resolve().then(() => invokes).then((m) => m.default));
      class LazyDep {
        constructor(loader) {
          __publicField(this, "loader");
          this.loader = loader;
        }
        load() {
          return this.loader();
        }
      }
      const modules = {
        ClipboardJS: lib(() => module.import("./dyn-clipboard.js").then((n) => n.c).then((m) => m.default)),
        invoke: () => libInvoke()
      };
      const LAZY_MODULES = {
        manualInvoke,
        ClipboardJS: new LazyDep(() => module.import("./dyn-clipboard.js").then((n) => n.c).then((m) => m.default)),
        motion: new LazyDep(() => module.import("./dyn-index5.js"))
      };
      if (!((_a = window.importDynamic) == null ? void 0 : _a.initialized)) {
        const importDynamic = function(name, cb) {
          var _a2;
          const m = (_a2 = modules[name]) == null ? void 0 : _a2.call(modules);
          if (typeof cb === "function") {
            cb(m);
          }
          return m;
        };
        importDynamic.initialized = true;
        if ((_b = window._dynamics) == null ? void 0 : _b.length) {
          window._dynamics.forEach(([name, resolve]) => {
            importDynamic(name).then(resolve);
          });
          window._dynamics = [];
        }
        window.importDynamic = importDynamic;
      }
      function autoInvoke() {
        console.info("[DYN] auto invoke");
        libInvoke().then((invoke2) => {
          Array.from(document.querySelectorAll('script[dyn-invoke][type="application/json"]')).forEach((script) => {
            if (script instanceof HTMLScriptElement) {
              invoke2(script);
            }
          });
        });
      }
      function manualInvoke(el, cb) {
        let elem = el;
        if (typeof el === "string") {
          elem = document.querySelector(el);
        }
        if (!elem) return;
        const scripts = Array.from(elem.querySelectorAll('script[dyn-invoke][type="application/json"]'));
        libInvoke().then((invoke2) => {
          scripts.forEach((script) => invoke2(script, cb));
        });
      }
      async function callWithDeps(config) {
        if (Array.isArray(config)) {
          const fn = config.pop();
          const deps = config;
          if (typeof fn === "function") {
            fn.apply(null, await Promise.all(deps.map(async (depName) => {
              const name = depName.split(".")[0];
              const dep = get(LAZY_MODULES, name);
              const isLazyDep = dep instanceof LazyDep;
              if (isLazyDep) {
                const m = await dep.load();
                if (depName !== name) {
                  return get(m, depName.split(".").slice(1).join("."));
                }
                return m;
              }
              return get(LAZY_MODULES, depName);
            })));
          }
        }
      }
      window.ELEGOO_THEME = window.ELEGOO_THEME || [];
      const ELEGOO_THEME = window.ELEGOO_THEME;
      window.ELEGOO_THEME.push = new Proxy(ELEGOO_THEME.push, {
        apply(target, thisArg, args) {
          if (Array.isArray(args)) {
            args.forEach((config) => callWithDeps(config));
          }
          const result = Reflect.apply(target, thisArg, args);
          return result;
        }
      });
      ELEGOO_THEME.forEach((config) => callWithDeps(config));
      document.addEventListener("shopify:section:load", () => {
        autoInvoke();
      });
      if (window.location.host.startsWith("127.0.0.1")) ;
      else {
        autoInvoke();
      }
      const REACT_INVOKES = {
        "timeline": () => module.import("./dyn-timeline.js"),
        "retable": () => module.import("./dyn-retable.js"),
        "milestones": () => module.import("./dyn-milestones.js"),
        "media-3d-carousel": () => module.import("./dyn-media-3d-carousel.js"),
        "scroll-and-hover": () => module.import("./dyn-scroll-hover.js"),
        "user-story": () => module.import("./dyn-user-story.js"),
        "social-media-reviews": () => module.import("./dyn-social-media-reviews.js"),
        "sns-masonry": () => module.import("./dyn-sns-masonry.js"),
        "flip-clock": () => module.import("./dyn-flip-clock.js")
      };
      const INVOKES = {
        ...REACT_INVOKES,
        "startCarousel": () => module.import("./dyn-embla.js").then((n) => n.e).then((m) => m.startCarousel),
        "initChaoticEffect": () => module.import("./dyn-hero-effects.js").then((m) => m.initChaoticEffect),
        "parallax-banner": () => module.import("./dyn-parallax-banner.js").then((n) => n.ay),
        "expandable-cards": () => module.import("./dyn-scroll-follow-action.js").then((m) => m.initExpandableCards),
        "scroll-follow-video": () => module.import("./dyn-scroll-follow-action.js").then((m) => m.initScrollFollowVideo),
        "scroll-reveal": () => module.import("./dyn-scroll-follow-action.js").then((m) => m.ScrollReveal),
        "featured-product-with-video": () => Promise.resolve().then(() => featureProducts).then((m) => m.featuredProductWithVideo),
        "j2-sticky-indicator": () => module.import("./dyn-pdpj2.js").then((m) => m.StickyIndicator),
        "j2-polygon-highlight": () => module.import("./dyn-pdpj2.js").then((m) => m.PolygonHighlight),
        "j2-zoom-in": () => module.import("./dyn-pdpj2.js").then((m) => m.ZoomIn),
        "j2-reveal": () => module.import("./dyn-pdpj2.js").then((m) => m.ScrollReveal),
        "j2-sticky-progress": () => module.import("./dyn-pdpj2.js").then((m) => m.Progress),
        "j2-tutorial-carousel": () => module.import("./dyn-pdpj2.js").then((m) => m.TutorialCarousel),
        "j2-sticky-header": () => module.import("./dyn-pdpj2.js").then((m) => m.Header)
      };
      const getReactLib = lib(() => module.import("./dyn-setup-react.js"));
      const call = async (m, params, cb) => {
        const mod = await m;
        if (typeof mod === "function") {
          return mod(params);
        }
        if (params.container) {
          const container = params.container;
          const payload = params.payload;
          getReactLib().then(async (m2) => {
            const mount = await m2.getReactMountNode();
            const Comp = mod.default;
            const portalEl = typeof container === "string" ? document.querySelector(container) : container;
            if (portalEl) {
              const portal = m2.createPortalComponent(Comp, payload, portalEl, cb);
              mount.push(portal);
            }
          });
        } else {
          if (typeof mod.invoke === "function") {
            mod.invoke(params);
          } else {
            mod.default(params);
          }
        }
      };
      function invoke(strOrElement, cb) {
        const KEY_INVOKED = "__dyn_invoked";
        let jsonStr = "{}";
        let el = null;
        if (strOrElement instanceof HTMLScriptElement) {
          el = strOrElement;
          jsonStr = el.textContent || "{}";
        } else if (typeof strOrElement === "string") {
          try {
            el = document.querySelector(strOrElement);
            if (el) {
              jsonStr = el.textContent || "{}";
            }
          } catch {
          }
        }
        if (get(el, KEY_INVOKED)) {
          console.info("Already invoked:", el);
          return Promise.resolve();
        }
        const params = JSON.parse(jsonStr);
        if (params.type in INVOKES) {
          call(INVOKES[params.type](), params, cb);
          if (el) el[KEY_INVOKED] = true;
        }
      }
      const invokes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
        __proto__: null,
        default: invoke
      }, Symbol.toStringTag, { value: "Module" }));
      function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
      }
      function featuredProductWithVideo(params) {
        function init() {
          let latestActive = 0;
          const PREFIX = "feat-p--";
          const root = document.querySelector(`#shopify-section-${params.payload.section_id}`);
          const containers = Array.from(root.querySelectorAll(`.${PREFIX}container`));
          containers.forEach((container) => {
            const nav = container.querySelector(`.${PREFIX}nav`);
            if (!nav) return;
            const viewport = nav.querySelector(`.${PREFIX}nav-viewport`);
            if (!viewport) return;
            const navItems = Array.from(container.querySelectorAll(`.${PREFIX}nav button`));
            const blockItems = Array.from(container.querySelectorAll(`.${PREFIX}item`));
            const videoTemplates = Array.from(container.querySelectorAll(`.${PREFIX}video-container template`));
            const videoPlayer = container.querySelector(`.${PREFIX}video-player`);
            const videoPlayerMobile = container.querySelector(".feat-p--video-player-mobile");
            if (!videoPlayer || !videoPlayerMobile) return;
            viewport.addEventListener("scroll", debounce({
              delay: 150
            }, () => {
              const found = navItems.find((el) => el.classList.contains("active"));
              if (!found) return;
              const value = found.offsetLeft - (viewport.scrollLeft || 0) + "px";
              nav.style.setProperty("--active-nav-left", value);
            }));
            window.addEventListener("resize", function() {
              updateActive(latestActive);
            });
            const updateActive = (index) => {
              var _a2;
              latestActive = index;
              const activeButton = navItems[index];
              if (!activeButton) return;
              const hasHorizontalScrollbar = viewport.scrollWidth > viewport.clientWidth;
              const scrollLeft = (() => {
                if (index !== 0 && hasHorizontalScrollbar) {
                  return activeButton.offsetLeft - (viewport.offsetWidth - activeButton.offsetWidth) / 2;
                }
                return 0;
              })();
              nav.style.setProperty("--active-nav-width", activeButton.offsetWidth + "px");
              nav.style.setProperty("--active-nav-left", activeButton.offsetLeft - scrollLeft + "px");
              viewport.scrollTo({
                left: scrollLeft,
                behavior: "smooth"
              });
              nav.classList.toggle("has-scrollbar", hasHorizontalScrollbar);
              blockItems.forEach((el, i) => {
                el.classList.toggle("active", i === index);
              });
              navItems.forEach((el, i) => {
                el.classList.toggle("active", i === index);
              });
              const videoTemplate = videoTemplates[index];
              if (isMobile()) {
                videoPlayer.innerHTML = "";
              } else {
                videoPlayerMobile.innerHTML = "";
              }
              if (videoTemplate) {
                const videoContent = videoTemplate.content.cloneNode(true);
                (_a2 = isMobile() ? videoPlayerMobile : videoPlayer) == null ? void 0 : _a2.replaceChildren(videoContent);
              }
            };
            updateActive(0);
            container.addEventListener("click", function(evt) {
              const target = evt.target;
              if (target.closest(".feat-p--nav button")) {
                updateActive(navItems.indexOf(target));
              }
            });
            container.addEventListener("shopify:section:load", () => {
              updateActive(latestActive);
            });
            container.addEventListener("shopify:block:select", (evt) => {
              const index = blockItems.indexOf(evt.target);
              if (index === -1) return;
              updateActive(index);
            });
          });
        }
        init();
      }
      const featureProducts = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
        __proto__: null,
        featuredProductWithVideo
      }, Symbol.toStringTag, { value: "Module" }));
    }
  };
});
